import { KYMW0900Model } from '../kymw0900.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * デフォルト消費税情報取得を取得するサービス
 *
 * @export GetDefaultConsumeTaxInfoService
 * @class GetDefaultConsumeTaxInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetDefaultConsumeTaxInfoService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0C00Model}
   * @memberof GetDefaultConsumeTaxInfoService
   */
  model: KYMW0900Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetDefaultConsumeTaxInfoService
   */
  private successFunc: Function;

  vo = {
    classCode: '',
    smallClassCode: '',
    delivCatalogID: '',
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetDefaultConsumeTaxInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ClassCode: this.vo.classCode,
        SmallClassCode: this.vo.smallClassCode,
        DelivCatalogID: this.vo.delivCatalogID,                
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetDefaultConsumeTaxInfoService
   */
  execute(model: any, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getDefaultConsumeTaxInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetDefaultConsumeTaxInfoService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.setConsumeTax(data);
    }
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
